import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Eye = ({ className }) => {
  return (
    <svg
      viewBox='0 0 349 349'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classnames('icon', 'icon-eye', { [className]: className })}
    >
      <path
        d='M0 0V349H349V0H0ZM329.369 329.369H19.6313V85.6141H329.369V329.369ZM19.6313 65.9828V19.6313H329.369V65.9828H19.6313ZM315.736 33.2641H296.105V52.8953H315.736V33.2641ZM256.842 33.2641H237.211V52.8953H256.842V33.2641ZM286.289 33.2641H266.658V52.8953H286.289V33.2641ZM299.731 199.23C297.454 197.117 243.046 147.384 174.5 147.384C105.954 147.384 51.5593 197.117 49.269 199.23L41.5119 206.428L49.269 213.626C51.5457 215.739 105.954 265.472 174.5 265.472C243.046 265.472 297.441 215.739 299.731 213.626L307.488 206.428L299.731 199.23ZM213.912 206.428C213.912 228.159 196.231 245.841 174.5 245.841C152.769 245.841 135.088 228.159 135.088 206.428C135.088 184.697 152.769 167.016 174.5 167.016C196.231 167.016 213.912 184.697 213.912 206.428ZM123.254 177.158C118.306 185.788 115.456 195.781 115.456 206.428C115.456 217.075 118.306 227.068 123.254 235.698C100.188 226.864 81.6605 214.267 71.4087 206.428C81.6605 198.589 100.188 185.992 123.254 177.158ZM225.746 235.698C230.694 227.068 233.544 217.075 233.544 206.428C233.544 195.781 230.694 185.788 225.746 177.158C248.812 185.992 267.339 198.589 277.591 206.428C267.339 214.267 248.812 226.864 225.746 235.698Z'
        fill='currentColor'
      />
    </svg>
  );
};

Eye.propTypes = {
  className: PropTypes.string,
};

export default Eye;
